import { Component, ViewChild } from '@angular/core';
import { DialogService } from 'src/app/layout/services/dialog.service';
import { HttpClient } from '@angular/common/http';
import { MatDialog } from '@angular/material/dialog';
import { Subject } from 'rxjs';
import Swal from 'sweetalert2';
import { DataTableDirective } from 'angular-datatables';
import { DataTablesResponse } from 'src/app/interfaces/data-table-response.interface';
import { environment } from 'src/environments/environment';
import { ConfigService } from './config.service';
import { AddConfigComponent } from './add-config/add-config.component';
import { IConfigUpdatePayload } from './config.interface';
import { helper } from 'src/environments/helper';
import { EditConfigComponent } from './edit-config/edit-config.component';
import { PermissionsService } from '../../../../../services/permissions.service';

@Component({
    selector: 'app-configurari',
    templateUrl: './configurari.component.html',
    styleUrls: ['./configurari.component.scss'],
})
export class ConfigurariComponent {
    @ViewChild(DataTableDirective, { static: false })
    dtElement!: DataTableDirective;
    helper = helper;

    isLoading = false;
    dtOptions: any = {};
    dtTrigger: Subject<any> = new Subject<any>();
    dtInstance!: DataTables.Api;

    dtLink =
        environment.interop.basePath +
        environment.interop.urbanism.settings.configurations.getConfigurationsDT;

    resetForm() {
        this.rerenderDT();
    }

    applyFilters(): void {
        this.rerenderDT(true);
    }

    constructor(
        private dialogService: DialogService,
        private http: HttpClient,
        private dialog: MatDialog,
        private configService: ConfigService,
        public permissionsService: PermissionsService
    ) { }

    ngOnInit(): void {
        this.renderDT();
    }

    ngOnDestroy(): void {
        this.dtTrigger.unsubscribe();
    }

    ngAfterViewInit(): void {
        this.dtTrigger.next('');
    }

    renderDT() {
        this.isLoading = true;
        this.dtOptions = {
            pagingType: 'full_numbers',
            responsive: true,
            pageLength: 25,
            searching: false,
            lengthMenu: [10, 25, 50, 100],
            serverSide: true,
            ajax: (dataTablesParameters: any, callback: any) => {
                this.isLoading = true;

                this.http
                    .post<DataTablesResponse>(
                        this.dtLink, // datatable link, we need this
                        dataTablesParameters // parameters for filtering, send here
                    )
                    .subscribe((resp: any) => {
                        this.isLoading = false;
                        callback({
                            recordsTotal: resp.data.recordsTotal,
                            recordsFiltered: resp.data.recordsFiltered,
                            data: resp.data.data,
                        });
                    });
            },
            language: environment.config.romanianLanguageDataTable,
            columns: [
                {
                    title: 'ID',
                    data: 'id_configuration',
                },
                {
                    title: 'Denumire',
                    data: 'name',
                },
                {
                    title: 'Valoare',
                    data: 'value',
                },
                {
                    title: 'Acțiuni',
                    data: null,
                    className: 'all',
                    orderable: false,
                    render: () => {
                        return `
              <button class="action-btn edit">
                <img class="btn-img" src="../../../../assets/icons/edit.svg" alt="edit"/>
              </button>
       
            `;
                    },
                },
            ],
            rowCallback: (row: Node, data: any[] | any) => {
                const lastTd = (row as HTMLElement).querySelector('td:last-child');
                const editIcon = lastTd?.querySelector('.edit') as HTMLElement;
                const deleteIcon = lastTd?.querySelector('.delete') as HTMLElement;

                if (editIcon) {
                    if (!this.permissionsService.hasPermission('urbanism-module.administrative.crons.update')) {
                        editIcon.style.display = 'none';
                    }
                    editIcon.addEventListener('click', () => {
                        this.openEditDialog(data);
                    });
                }

                return row;
            },
        };
    }

    rerenderDT(paginate: boolean = false): void {
        this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
            dtInstance.draw(paginate);
        });
    }

    openAddDialog() {
        const dialogRef = this.dialog.open(AddConfigComponent, {
            ...this.dialogService.getDialogConfig(),
        });
        dialogRef.afterClosed().subscribe(({ success }: { success: boolean }) => {
            if (success) {
                this.isLoading = true;
                this.rerenderDT();
                Swal.fire({
                    title: helper.dialogConfig.headers.success,
                    text: 'Adăugată cu succes!',
                    icon: 'success',
                    confirmButtonText: helper.dialogConfig.buttonLabels.close,
                    allowOutsideClick: false,
                });
            }
        });
    }

    openEditDialog(data: IConfigUpdatePayload) {
        const dialogRef = this.dialog.open(EditConfigComponent, {
            ...this.dialogService.getDialogConfig(),
            data,
        });

        dialogRef.afterClosed().subscribe(({ success }: { success: boolean }) => {
            if (success) {
                this.isLoading = true;
                this.rerenderDT();
                Swal.fire({
                    title: helper.dialogConfig.headers.success,
                    text: 'Actualizare cu succes!',
                    icon: 'success',
                    confirmButtonText: helper.dialogConfig.buttonLabels.close,
                    allowOutsideClick: false,
                });
            }
        });
    }
}
